import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import Projects from "./pages/Projects";
import Videos from "./pages/Videos";
import Resume from "./pages/Resume";
import Contact from "./pages/Contact";
import BlogPost from "./pages/BlogPost";
import ProjectPost from "./pages/ProjectPost";
import VideoPost from "./pages/VideoPost";
import Feedback from "./pages/Feedback";
import useReveal from "./hooks/useReveal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppInner() {
  useReveal();
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectPost />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/videos/:id" element={<VideoPost />} />
          <Route path="/resume" element={<Resume />} />
<Route path="/feedback" element={<Feedback />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;
